<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';
import CaptainEmptyState from './CaptainEmptyState.vue';

const emit = defineEmits(['click']);

const { t } = useI18n();

const STEPS = [
  ['ENDPOINT', 'i-lucide-globe'],
  ['PARAMS', 'i-lucide-list'],
  ['SCENARIO', 'i-lucide-sparkles'],
];

const steps = computed(() =>
  STEPS.map(([key, icon]) => ({
    icon,
    title: t(`CAPTAIN.CUSTOM_TOOLS.EMPTY_STATE.STEPS.${key}.TITLE`),
    description: t(`CAPTAIN.CUSTOM_TOOLS.EMPTY_STATE.STEPS.${key}.DESCRIPTION`),
  }))
);
</script>

<template>
  <CaptainEmptyState
    icon="i-lucide-plug"
    :title="t('CAPTAIN.CUSTOM_TOOLS.EMPTY_STATE.TITLE')"
    :subtitle="t('CAPTAIN.CUSTOM_TOOLS.EMPTY_STATE.SUBTITLE')"
    :steps="steps"
  >
    <template #actions>
      <Button
        :label="t('CAPTAIN.CUSTOM_TOOLS.ADD_NEW')"
        icon="i-lucide-plus"
        @click="emit('click')"
      />
    </template>
  </CaptainEmptyState>
</template>
